import { gql } from "@apollo/client";

const RATE_CLASS = gql`
  mutation CreateRating($input: CreateRatingInput!) {
    createRating(input: $input) {
      rating {
        id
      }
    }
  }
`;

export default RATE_CLASS;
